import { useMemo } from 'react';

/**
 * @description Return initial ServiceSidePanelFilters values
 */
function useFiltersValues(filterStructure, defaultValues) {
  const filtersValues = useMemo(() => {
    const {
      carriers,
      collectionTypes,
      deliveryTypes,
      serviceDetails,
      transitHours,
      tagTypes
    } = filterStructure;
    const carriersInitialValues = {};
    const collectionTypesInitialValues = {};
    const deliveryTypesInitialValues = {};
    const serviceDetailsInitialValues = {};
    const transitHoursInitialValues = {};
    const tagTypesInitialValues = {};
    carriers.forEach(carrier => {
      var _defaultValues$carrie;
      carriersInitialValues[carrier.key] = (defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$carrie = defaultValues.carriers) === null || _defaultValues$carrie === void 0 ? void 0 : _defaultValues$carrie[carrier.key]) || false;
    });
    collectionTypes.forEach(collectionType => {
      var _defaultValues$collec;
      collectionTypesInitialValues[collectionType.key] = (defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$collec = defaultValues.collectionTypes) === null || _defaultValues$collec === void 0 ? void 0 : _defaultValues$collec[collectionType.key]) || false;
    });
    deliveryTypes.forEach(deliveryType => {
      var _defaultValues$delive;
      deliveryTypesInitialValues[deliveryType.key] = (defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$delive = defaultValues.deliveryTypes) === null || _defaultValues$delive === void 0 ? void 0 : _defaultValues$delive[deliveryType.key]) || false;
    });
    serviceDetails.forEach(serviceDetail => {
      var _defaultValues$servic;
      serviceDetailsInitialValues[serviceDetail.key] = (defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$servic = defaultValues.serviceDetails) === null || _defaultValues$servic === void 0 ? void 0 : _defaultValues$servic[serviceDetail.key]) || false;
    });
    transitHours.forEach(transitHours => {
      var _defaultValues$transi;
      transitHoursInitialValues[transitHours.key] = (defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$transi = defaultValues.transitHours) === null || _defaultValues$transi === void 0 ? void 0 : _defaultValues$transi[transitHours.key]) || false;
    });
    tagTypes.forEach(tagType => {
      var _defaultValues$tagTyp;
      tagTypesInitialValues[tagType.key] = (defaultValues === null || defaultValues === void 0 ? void 0 : (_defaultValues$tagTyp = defaultValues.tagTypes) === null || _defaultValues$tagTyp === void 0 ? void 0 : _defaultValues$tagTyp[tagType.key]) || false;
    });
    return {
      carriers: {
        ...carriersInitialValues
      },
      collectionTypes: {
        ...collectionTypesInitialValues
      },
      deliveryTypes: {
        ...deliveryTypesInitialValues
      },
      serviceDetails: {
        ...serviceDetailsInitialValues
      },
      transitHours: {
        ...transitHoursInitialValues
      },
      tagTypes: {
        ...tagTypesInitialValues
      }
    };
  }, [filterStructure, defaultValues]);
  return filtersValues;
}

export { useFiltersValues };
//# sourceMappingURL=useFiltersValues.js.map
